import Keycloak from 'keycloak-js';

const keycloakConfig = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

keycloakConfig.onTokenExpired = () => {
  console.warn('Token expirado');
};

export default keycloakConfig;
